import React from "react";
import { Button, Spinner } from "react-bootstrap";

function LoaderSubmitButton(
    {
        loading = false,
        name,
        valid = true,
        className,
        icon = null,
        style = {}
    }) {

    return (
        <React.Fragment>
            {loading ?
                <Button
                    className={className || "btn btn-chartreuse btn-height btn-block"}
                    disabled
                    style={style}
                >
                    {icon && <i className={icon}></i>}
                    Loading...
                    <Spinner
                        className="ml-2"
                        animation="grow"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                    />
                </Button>
                :
                <Button
                    type="submit"
                    style={style}
                    className={className || "btn btn-chartreuse btn-height btn-block"}
                    disabled={!valid}
                >
                    {icon && <i className={icon}></i>}
                    {name}
                </Button>
            }
        </React.Fragment>
    );
}

export default LoaderSubmitButton;